<ngx-intl-tel-input
	[cssClass]="'phone-selector'"
	[enableAutoCountrySelect]="true"
	[enablePlaceholder]="true"
	[customPlaceholder]="placeholder"
	[preferredCountries]="preferredCountries"
	[searchCountryFlag]="true"
	[searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
	[selectedCountryISO]="CountryISO.UnitedStates"
	[phoneValidation]="true"
	[separateDialCode]="separateDialCode"
	[numberFormat]="PhoneNumberFormat.International"
	[(ngModel)]="number"
	(ngModelChange)="emitNumber()"
></ngx-intl-tel-input>
